import { render, staticRenderFns } from "./browseRecords.vue?vue&type=template&id=74facc27&scoped=true&"
import script from "./browseRecords.vue?vue&type=script&lang=js&"
export * from "./browseRecords.vue?vue&type=script&lang=js&"
import style0 from "./browseRecords.vue?vue&type=style&index=0&id=74facc27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74facc27",
  null
  
)

export default component.exports